import { CfQueryOrder, ColOrder } from "types/generic/types";

const CF_COL_ORDER = "first";

export const convertCfColOrderProps = (
  cfProp: CfQueryOrder | undefined | null,
): ColOrder | undefined => {
  if (!cfProp) return undefined;
  return {
    xsColOrder: cfProp.default ? CF_COL_ORDER : undefined,
    smColOrder: cfProp.sm ? CF_COL_ORDER : undefined,
    mdColOrder: cfProp.md ? CF_COL_ORDER : undefined,
    lgColOrder: cfProp.lg ? CF_COL_ORDER : undefined,
    xlColOrder: cfProp.xl ? CF_COL_ORDER : undefined,
  };
};
